'use client'

import { FC } from 'react'

import CustomerCaseStudyBox from '@/components/CustomerCaseStudyBox'

const LogixboardCaseStudyBox: FC<{}> = () => {
    return (
        <CustomerCaseStudyBox
            reference={'/customers/logixboard'}
            sx={{
                backgroundColor: '#011822',
            }}
            chipLabels={[`Emissions intelligence`, `Vessel tracking`, `API`]}
            subText={
                'Lune was the best partner for translating detailed information into something understandable. Instead of just presenting all of the data and hoping someone can make sense of it, the Lune team knew how to curate the data and make it understandable to people.'
            }
            mainText={`30+ freight forwarders winning tenders using Logixboard's CO₂ emissions reporting tool`}
            avatar={{
                title: 'Erin Miska',
                subtitle: `Product Marketing Manager at Logixboard`,
            }}
            counterBox={{
                adoption: `30+ paying customers`,
                usageFallback: `1,100,000+ shipments`,
            }}
            images={{
                avatar: {
                    source: `/images/logixboard-case-study/erin-miska.png`,
                    altText: 'Erin Miska',
                },
                desktop: {
                    source: '/images/logixboard-case-study/logixboard-case-study-box-desktop.png',
                    altText: 'Container ship',
                },
                mobile: {
                    source: `url('/images/logixboard-case-study/logixboard-case-study-box-mobile.png')`,
                },
            }}
        />
    )
}

export default LogixboardCaseStudyBox
